import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { layers } from './layer-config';
import { selectors } from '../../store/dux/n-protectant-dux';
import RxMap from '../map/RxGoogleMap';
import { Spinner } from '../../components/Spinner';

const TIMINGS = {
  spring: 'spring',
  'fall/early spring': 'fall-early-spring',
  early_sidedress: 'early-sidedress',
  late_sidedress: 'late-sidedress',
};

export default function Map() {
  const mapApi = useRef();
  const fields = useSelector(selectors.fields);

  const showLayer = useCallback(
    (layer) =>
      fields?.some((field) => field.stats && timingMatch(layer, field.stats)),
    [fields],
  );

  const layerVisibilities = useMemo(
    () =>
      Object.fromEntries(layers.map((layer) => [layer.id, showLayer(layer)])),
    [showLayer],
  );

  useEffect(() => {
    layers.forEach((layer) => {
      const toggle = showLayer(layer) ? 'showLayer' : 'hideLayer';
      mapApi?.current?.[toggle]?.(layer.id);
    });
  }, [showLayer]);

  if (fields) {
    return (
      <RxMap
        apiRef={mapApi}
        layers={layers}
        layerVisibilities={layerVisibilities}
      />
    );
  }

  return <Spinner />;
}

function buildStatSuffix(stat) {
  const [timing, value] = stat;
  const mappedTiming = TIMINGS[timing];
  return `${value.product}-${mappedTiming}`;
}

function timingMatch(layer, stats) {
  return Object.entries(stats).some((stat) => {
    const suffix = buildStatSuffix(stat);
    return layer.id.endsWith(suffix);
  });
}
